import * as React from "react";
import { useLogoutMutation } from "../../reducers/registerapi";

interface ICheckoutUserNotClientProps {
    message: string;
}

const CheckoutUserNotClient = ({ message }: ICheckoutUserNotClientProps) => {
    const [logout, { isLoading: isLoggingOut }] = useLogoutMutation();

    const handleLogout = async () => {
        try {
            await logout().unwrap();
            // Logout successful - RTK Query invalidation should handle refetching getAuth
            // You might want to redirect the user here
            console.log("Logout successful");
            // navigate('/login');
        } catch (error) {
            console.error('Failed to logout:', error);
        }
    };


        return (
            <>
                <h3>Client Account</h3>
                <div className="alert alert-warning" role="alert">
                    <p>{message}</p>
                    <p className="mb-0 text-center"><button className="btn btn-sm btn-outline-secondary" onClick={handleLogout} disabled={isLoggingOut}>
                        {isLoggingOut ? 'Logging out...' : 'Logout'}
                    </button></p>
                </div>
            </>
        );

};

export default CheckoutUserNotClient;
